<template>
  <div>
    <LoadingWidget v-if="loading" />

    <section v-else-if="items.length" class="pt-0">
      <v-container class="pt-0">
        <TitleWidget>
          {{ title }}
        </TitleWidget>

        <div class="justify-center mt-6 mt-sm-8 mt-md-10 grid-list">
          <PropertyCard
            v-for="(item, keyItems) in items"
            :key="keyItems"
            :is-terrain="isTerrain"
            v-bind="item"
          />
        </div>

        <ButtonWidget
          class="mt-8 mt-md-12"
          align="center"
          exact-path
          :to="path"
        >
          Ver Todos
        </ButtonWidget>
      </v-container>
    </section>
  </div>
</template>

<script>
import LoadingWidget from "../widgets/LoadingWidget.vue";
import TitleWidget from "../widgets/TitleWidget.vue";
import PropertyCard from "../cards/PropertyCard.vue";
import ButtonWidget from "../widgets/ButtonWidget.vue";

const _config = {
  mod: "properties",
};

const _pagination = {
  itemsPerPage: 8,
  returnTotalItems: 1,
};

const _data = {
  loading: true,
  totalItems: 0,
};

export default {
  props: {
    category: {
      type: String,
      default: "",
    },
    business: {
      type: Number,
      validator: (v) => [1, 2].includes(v), // 1 = venda 2 = locacao
      default: 1,
    },
    price: {
      type: Number,
      required: true,
    },
    isTerrain: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    ..._data,
  }),
  computed: {
    title() {
      if (this.isTerrain) return "Terrenos Relacionados";

      return "Imóveis Relacionados";
    },
    items() {
      return this.$rest(_config.mod).list;
    },
    path() {
      if (this.isTerrain) return "/terrenos";

      return "/imoveis";
    },
  },
  methods: {
    getList() {
      this.loading = true;

      const params = {
        ..._pagination,
      };

      const priceVariation = this.business === 1 ? 20 : 50;

      params.minPrice =
        this.price - (this.price / 100) * priceVariation > 0
          ? this.price - (this.price / 100) * priceVariation
          : 0;

      params.maxPrice = this.price + (this.price / 100) * priceVariation;

      if (this.isTerrain) params.category = "Terreno, Terreno Comercial";
      else if (this.category) params.category = this.category;

      this.$rest(_config.mod)
        .get({
          params,
          save: (state, data) => {
            if (data?.list?.length) {
              state.list = data.list;
              this.totalItems = data.totalItems;
            } else state.list = data;
          },
        })
        .finally(() => (this.loading = false));
    },
  },
  watch: {
    $route() {
      this.getList();
    },
  },
  created() {
    this.getList();
  },
  components: {
    LoadingWidget,
    TitleWidget,
    PropertyCard,
    ButtonWidget,
  },
};
</script>

<style lang="scss" scoped>
.grid-list {
  display: grid;
  gap: 20px 12px;
  grid-template-columns: repeat(auto-fit, 300px);

  @media screen and (max-width: 959.9px) {
    grid-template-columns: repeat(2, calc(50% - 6px));
  }

  @media screen and (max-width: 599.9px) {
    grid-template-columns: 1fr;
  }
}
</style>
